import { Row } from "antd";
import { BatchDatePicker } from "../BatchModal/BatchDate";
import { InitDayBtn } from "./InitDayBtn";
import { PrintDropdown } from "./PrintDropdown";
import { CreateBatchBtn } from "./CreateBatchBtn";
import { ExportDropdown } from "./ExportDropdown";

type HeaderProps = {
  request: any;
  id: string | null;
  isOpenEditModal: boolean;
  setId: React.Dispatch<React.SetStateAction<string | null>>;
  setIsOpenEditModal: React.Dispatch<React.SetStateAction<boolean>>;
  reloadData: () => void;
};

export const Header = ({
  request,
  id,
  isOpenEditModal,
  setId,
  setIsOpenEditModal,
  reloadData,
}: HeaderProps) => {
  return (
    <Row className="w-100 d-flex justify-space-between">
      <BatchDatePicker request={request} />
      <Row className="d-block">
        <PrintDropdown request={request} />

        <ExportDropdown request={request} />

        <InitDayBtn reloadData={reloadData} />

        <CreateBatchBtn
          id={id}
          isOpenEditModal={isOpenEditModal}
          setId={setId}
          setIsOpenEditModal={setIsOpenEditModal}
          reloadData={reloadData}
        />
      </Row>
    </Row>
  );
};
